import React, { Suspense } from 'react';
const BankAccountComponent = React.lazy(() => import('../Component/BankAccountComponent/BankAccountComponent'));

function BankAccountPage(props) {
  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <BankAccountComponent />
      </Suspense>
    </div>
  );
}

export default BankAccountPage;
